import React from "react"
import { storyblokEditable } from "@storyblok/react"

import Markdown from "react-markdown"
import { Timeline } from "gatsby-theme-gba"

const TimelineEditable = ({ blok }) => (
  <div {...storyblokEditable(blok)} key={blok._uid}>
    <Timeline
      year={blok.year}
      toggleOn={blok.toggle || false}
      colLeft={<Markdown>{blok.left}</Markdown>}
      colRight={<Markdown>{blok.right}</Markdown>}
    />
  </div>
)

export default TimelineEditable
